import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {PARTYCATEGORY, PARTYROLE} from "party/partyDomain";
import {loc} from "core/common/config/locales";

const gridLocation = 'partyContacts';

@observer
export default class ContactPersonList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`Contact persons`;
  static icon = 'female';
  static rootPage = true;
  static protectedPage = true;

  static fetchData(params) {
    console.log("ContactPersonList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }


  render() {
    let {params, query} = this.props;

    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                         multiUpdateSecurable={SECURABLE.partyGridUpdate} >
        <ZzFlatButtonRoute onGridToolbar routeName="partyDetail" params={{id: 'new'}} query={{partyCategory: PARTYCATEGORY.PE, roles:PARTYROLE.CONTACT_ROLE}} label={loc.i18n`New Contact`} permission={PERMISSION.New}/>
      </GridCompConnected>
    );
  }

}






// WEBPACK FOOTER //
// ./src/party/page/contactPersonList.tsx